import type { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useUserProfilSelectStyle = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "column",
            width: "240px",
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(0),
        },
        label: {
            fontSize: "12px",
        },
        select: {
            minWidth: "150px",
            display: "flex",
            flexDirection: "column",
        },
    })
);
